import React, { useEffect, useState, useRef } from "react";
import RokuLogo from "../../../../assets/images/roku.png";
import GooglePlayStore from "../../../../assets/images/gpay.svg";
import AppStore from "../../../../assets/images/app_store.svg";
import TizenImg from "../../../../assets/images/tizen.svg";
import WebOsImg from "../../../../assets/images/webos.svg";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { connect } from "react-redux";
import { fetchFooterMenu } from "../../../../Redux/actions/fecthFooterMenuActions";
import { Button } from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

import {
  ANDROIDAPP,
  ROKUAPP,
  DONATIONURL,
  IOSAPP,
  LOGO,
} from "../../../../utility/constants";

import CustomModal from "../../../../components/modal/modalCustom";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import UAParser from "ua-parser-js";
import { ModalContext } from "../../../../components/modal/modalContext";

const FooterMenu = ({
  isMedium,
  menuItems,
  fetchFooterMenu,
  token,
  menu,
  commonData,
}) => {
  // =========================================================
  // Refs
  // =========================================================

  const searchRef = useRef(null);

  // =========================================================
  // States
  // =========================================================

  const [isMacOS, setIsMacOS] = useState(false);
  const [footerMenuData, setFooterMenuData] = useState([]);

  const windowSize = useRef([
    window.innerWidth,
    window.innerHeight,
  ]);

  const [windowWidth, setwindowWidth] = useState(
    windowSize.current[0]
  );

  const [isOpenSearch, setIsOpenSearch] = useState("");
  const [open, setOpen] = React.useState(false);

  const [state, setState] = useState({
    sideMenuItems: [],
    topMenu: [],
    keyword: "",
    focusOnSearch: false,
    isLogin: false,
    commondataItems: {},
  });

  const { commondataItems } = state;

  // E-Voting modal
  const [isUrlModal, setIsUrlModal] = useState(false);

  // AGM modal
  const [isAgmModal, setIsAgmModal] = useState(false);

  // =========================================================
  // PDF URLs
  // =========================================================

  const EVOTING_RESULT_URL =
    "https://ott.shalomtv.tv/e-voting_2025.pdf";

  const AGM_NOTICE_2026_URL =
    "https://ott.shalomtv.tv/AGM_Notice_2026.pdf";

  // =========================================================
  // Effects
  // =========================================================

  useEffect(() => {
    const parser = new UAParser();
    const os = parser.getOS();

    setIsMacOS(os.name === "Mac OS");
  }, []);

  useEffect(() => {
    let userAgent =
      navigator.userAgent ||
      navigator.vendor ||
      window.opera;

    if (
      /iPad|iPhone|iPod/.test(userAgent) &&
      !window.MSStream
    ) {
      const rootElement = document.querySelector("#root");

      if (rootElement) {
        rootElement.classList.add("ipad");
      }
    }
  }, []);

  useEffect(() => {
    const footerMenuApiCall = async () => {
      try {
        if (isMedium === false) {
          await fetchFooterMenu();
        }
      } catch (error) {}
    };

    const timeout = setTimeout(
      footerMenuApiCall,
      600
    );

    return () => {
      clearTimeout(timeout);
    };
  }, [fetchFooterMenu, isMedium]);

  useEffect(() => {
    if (commonData ?? false) {
      try {
        if (commonData.status === "Success") {
          setState((prevState) => ({
            ...prevState,
            commondataItems: commonData.data,
          }));
        }
      } catch (error) {}
    }

    if (menuItems ?? false) {
      try {
        if (menuItems?.status === "Success") {
          setFooterMenuData(menuItems.menu);
        }
      } catch (error) {}
    }
  }, [menuItems, commonData]);

  // =========================================================
  // Event Handlers
  // =========================================================

  const redirectTodonation = (value) => {
    if (value) {
      window.open(value, "_blank");
    }
  };

  // =========================================================
  // E-Voting Result
  // =========================================================

  const openNotice = (e) => {
    e.preventDefault();
    setIsUrlModal(true);
  };

  const handleCloseModal = () => {
    setIsUrlModal(false);
  };

  // =========================================================
  // AGM Notice 2026
  // =========================================================

  const openAgmNotice = (e) => {
    e.preventDefault();
    setIsAgmModal(true);
  };

  const handleCloseAgmModal = () => {
    setIsAgmModal(false);
  };

  // =========================================================
  // Search
  // =========================================================

  const searchCall = () => {
    document
      .querySelector("html")
      .classList.add("overflow-hidden");

    setIsOpenSearch(true);

    setTimeout(() => {
      if (searchRef.current) {
        searchRef.current.focus();
      }
    }, 100);
  };

  const handleClose = () => {
    setOpen(false);

    document
      .querySelector("html")
      .classList.remove("overflow-hidden");
  };

  const handleInputSearchChange = (event) => {
    const keywordvalue = event.target.value;

    setState((prevState) => ({
      ...prevState,
      keyword: keywordvalue,
    }));
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      const searchKeyword = state.keyword;

      if (searchKeyword?.trim()) {
        const location =
          `/search/${state.keyword.trim()}`;

        window.location.href = location;
      } else {
        return false;
      }
    }
  };

  const gotoSearchPage = () => {
    const searchKeyword = state.keyword;

    if (searchKeyword?.trim()) {
      const location =
        `/search/${state.keyword.trim()}`;

      window.location.href = location;
    } else {
      return false;
    }
  };

  // =========================================================
  // iOS Device Check
  // =========================================================

  const isIOSDevice = () => {
    if (typeof navigator === "undefined") {
      return false;
    }

    return (
      /iPhone|iPad|iPod/i.test(
        navigator.userAgent
      ) ||
      (navigator.platform === "MacIntel" &&
        navigator.maxTouchPoints > 1)
    );
  };

  // =========================================================
  // Render
  // =========================================================

  return (
    <>
      {/* =====================================================
          E-Voting Result Modal
          ===================================================== */}

      {isUrlModal && (
        <CustomModal
          fullScreen={true}
          isOpen={isUrlModal}
          handleClose={handleCloseModal}
        >
          {isIOSDevice() ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                flexDirection: "column",
                padding: "20px",
              }}
            >
              <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "1px solid #333",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    EVOTING_RESULT_URL,
                    "_blank"
                  )
                }
              >
                Open PDF
              </button>
            </div>
          ) : (
            <iframe
              id="pdf-iframe"
              src={`${EVOTING_RESULT_URL}#toolbar=1&navpanes=1&scrollbar=0`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              allowFullScreen
              scrolling="auto"
              title="E-Voting Result"
            ></iframe>
          )}
        </CustomModal>
      )}

      {/* =====================================================
          AGM Notice 2026 Modal
          ===================================================== */}

      {isAgmModal && (
        <CustomModal
          fullScreen={true}
          isOpen={isAgmModal}
          handleClose={handleCloseAgmModal}
        >
          {isIOSDevice() ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
                flexDirection: "column",
                padding: "20px",
              }}
            >
              <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "6px",
                  border: "1px solid #333",
                  cursor: "pointer",
                }}
                onClick={() =>
                  window.open(
                    AGM_NOTICE_2026_URL,
                    "_blank"
                  )
                }
              >
                Open PDF
              </button>
            </div>
          ) : (
            <iframe
              id="agm-pdf-iframe"
              src={`${AGM_NOTICE_2026_URL}#toolbar=1&navpanes=1&scrollbar=0`}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
              allowFullScreen
              scrolling="auto"
              title="AGM Notice 2026"
            ></iframe>
          )}
        </CustomModal>
      )}

      {/* =====================================================
          Footer
          ===================================================== */}

      <footer
        className="mt-2"
        id="footermain"
      >
        <Grid
          container
          spacing={0}
          sx={{ m: "0" }}
          className="w-100 footerContainer"
        >
          {/* =================================================
              Logo Section
              ================================================= */}

          <Grid
            item
            md={2}
            className="pt-0 item1 flex-column"
          >
            <div className="footer_logo_wrapper">
              <Link to="/">
                {localStorage.getItem("logo") ? (
                  <img
                    src={`${
                      localStorage.getItem("logo")
                        ? localStorage.getItem("logo")
                        : menu.logo_url
                    }/width=60/height=80/quality=60`}
                    alt="Logo"
                    className="footer_logo"
                  />
                ) : (
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={120}
                    height={40}
                    style={{
                      borderRadius: "50px",
                    }}
                  />
                )}
              </Link>

              <span className="logoTxt">
                Shalom Television
              </span>
            </div>
          </Grid>

          {/* =================================================
              Footer Menu Items
              ================================================= */}

          <Grid
            item
            md={6}
            className="pt-0 footer_nav item2 px-0"
          >
            <ul className="list list-inline mb-0 header_Tabs">

              {/* Dynamic Footer Menu */}

              {footerMenuData?.length > 0 &&
                footerMenuData.map((item, i) => (
                  <li
                    className="list-inline-item"
                    key={i}
                  >
                    <Link
                      to={{
                        pathname: `/static/${item.slug}`,
                        state: {
                          name: item.cat_name,
                          slug: item.slug,
                        },
                      }}
                      exact="true"
                      aria-label="Toggle navigation"
                    >
                      {item.cat_name}
                    </Link>
                  </li>
                ))}

              {/* =================================================
                  E-Voting Result
                  ================================================= */}

              <li
                className="list-inline-item"
                key="notice"
              >
                <Link
                  to="#"
                  onClick={(e) =>
                    openNotice(e)
                  }
                  exact="true"
                  aria-label="E-Voting Result"
                >
                  E-Voting Result
                </Link>
              </li>

              {/* =================================================
                  AGM Notice 2026
                  ================================================= */}

              <li
                className="list-inline-item"
                key="agm-notice-2026"
              >
                <Link
                  to="#"
                  onClick={(e) =>
                    openAgmNotice(e)
                  }
                  exact="true"
                  aria-label="AGM Notice 2026"
                >
                  AGM Notice 2026
                </Link>
              </li>
            </ul>
          </Grid>

          {/* =================================================
              App Download Section
              ================================================= */}

          <Grid
            item
            md={4}
            className="pt-0 px-5 ml-2 item3 align-items-center justify-content-start"
          >
            <div className="d-flex align-items-center custom-justify flex-wrap gap-2">

              {/* Android */}

              {commondataItems?.live_store_url?.android_app ? (
                <span
                  className="cursor mx-1"
                  onClick={() =>
                    window.open(
                      commondataItems
                        ?.live_store_url
                        ?.android_app,
                      "_blank"
                    )
                  }
                >
                  <img
                    src={GooglePlayStore}
                    width="90px"
                    alt="G Pay"
                  />
                </span>
              ) : (
                ""
              )}

              {/* iOS */}

              {commondataItems?.live_store_url?.ios_app ? (
                <span
                  className="cursor mx-1"
                  onClick={() =>
                    window.open(
                      commondataItems
                        ?.live_store_url
                        ?.ios_app,
                      "_blank"
                    )
                  }
                >
                  <img
                    src={AppStore}
                    width="90px"
                    alt="App Store"
                  />
                </span>
              ) : (
                ""
              )}

              {/* Roku */}

              {commondataItems?.live_store_url?.roku_app ? (
                <span
                  className="cursor mx-1"
                  onClick={() =>
                    window.open(
                      commondataItems
                        ?.live_store_url
                        ?.roku_app,
                      "_blank"
                    )
                  }
                >
                  <img
                    src={RokuLogo}
                    width="90px"
                    alt="Roku"
                  />
                </span>
              ) : (
                ""
              )}

              {/* Samsung Tizen */}

              {commondataItems?.live_store_url?.samsung_app ? (
                <span
                  className="cursor mx-1"
                  onClick={() =>
                    window.open(
                      commondataItems
                        ?.live_store_url
                        ?.samsung_app,
                      "_blank"
                    )
                  }
                >
                  <img
                    src={TizenImg}
                    width="90px"
                    alt="Tizen"
                  />
                </span>
              ) : (
                ""
              )}

              {/* LG WebOS */}

              {commondataItems?.live_store_url?.lg_tv_app ? (
                <span
                  className="cursor mx-1"
                  onClick={() =>
                    window.open(
                      commondataItems
                        ?.live_store_url
                        ?.lg_tv_app,
                      "_blank"
                    )
                  }
                >
                  <img
                    src={WebOsImg}
                    width="90px"
                    alt="Web OS"
                  />
                </span>
              ) : (
                ""
              )}
            </div>
          </Grid>
        </Grid>
      </footer>

      {/* =====================================================
          Copyright
          ===================================================== */}

      <div className="pl-5 pr-5 pt-3 pb-3 copyright">
        <p className="text-center mb-0">
          &copy;{" "}
          {commondataItems?.copyright?.text_data}
        </p>
      </div>

      {/* =====================================================
          Fixed Footer Navigation
          ===================================================== */}

      {windowWidth < 1200 && (
        <div
          className="fixedFooterNav align-items-center justify-content-between"
          id="aditionalfooter"
        >
          <Button>
            <Link
              to="/"
              className="d-flex flex-column justify-content-center"
            >
              <HomeIcon className="m-auto" />
              <label>Home</label>
            </Link>
          </Button>

          <Link to="/search">
            <Button>
              <SearchIcon />
              <label>Search</label>
            </Button>
          </Link>

          <Button
            onClick={() =>
              redirectTodonation(
                commondataItems?.donation?.url
              )
            }
          >
            <CurrencyExchangeIcon />
            <label>
              {commondataItems?.donation?.title}
            </label>
          </Button>
        </div>
      )}
    </>
  );
};

// =========================================================
// Redux
// =========================================================

const mapStateToProps = (state) => ({
  menu: state.menu.topMenuData,
  commonData: state.common.commonData,
  menuItems: state.footerMenu.menuItems,
  loading: state.footerMenu.loading,
  error: state.footerMenu.error,
});

const mapDispatchToProps = {
  fetchFooterMenu,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterMenu);

